import React from "react";
import { 
  Box, 
  Stack, 
  Typography, 
  Radio, 
  Chip, 
  Switch 
} from "@mui/material";

export function ParkingTypeSelector({
  parkingType,
  isSelected,
  isIncluded,        // UI: true=Included, false=Upgrade
  isUpgradeEligible,
  onToggle,
  onIncludedChange,
  onUpgradeChange,
}) {
  return (
    <Box
      border="1px solid"
      borderColor={isSelected ? "primary.main" : "divider"}
      borderRadius={2}
      px={2}
      py={1.4}
      bgcolor={isSelected ? "rgba(59,91,255,0.04)" : "transparent"}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Radio checked={isSelected} onChange={onToggle} />
          <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
            {parkingType.name}
          </Typography>
        </Stack>

        {isSelected && (
          <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
            <Chip
              size="small"
              label="Included"
              color={isIncluded ? "success" : "default"}
              onClick={() => onIncludedChange(true)}  // → isUpgrade = false
              sx={{ fontWeight: 700 }}
            />
            <Chip
              size="small"
              label="Upgrade"
              color={!isIncluded ? "warning" : "default"}
              onClick={() => onIncludedChange(false)} // → isUpgrade = true
              sx={{ fontWeight: 700 }}
            />

            {isIncluded && (
              <Stack direction="row" spacing={0.8} alignItems="center">
                <Typography sx={{ fontSize: 12 }} color="text.secondary">
                  Upgrade eligible?
                </Typography>
                <Switch
                  size="small"
                  checked={isUpgradeEligible}
                  onChange={(e) => onUpgradeChange(e.target.checked)}
                />
                <Typography sx={{ fontSize: 12 }} color="text.secondary">
                  {isUpgradeEligible ? "Yes" : "No"}
                </Typography>
              </Stack>
            )}
          </Stack>
        )}
      </Stack>
    </Box>
  );
}
